<template>
  <v-container fluid>
    <v-card>
      <h2 v-text="'About servicesystem'" />

      <h3 v-text="'This system'" />

      <v-list dense>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-list-item-title>
              Version {{ Version.Version }}
            </v-list-item-title>
            <v-list-item-subtitle>
              Minor {{ Version.Minor }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Revision {{ Version.Revision }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Build {{ Version.Build }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card class="ma-10 pa-4">
        <h4 v-text="'Licences'" />
        <v-list dense>
          <v-list-item v-for="(value, name) in Licences" :key="name" class="px-0">
            <v-list-item-content>
              <v-list-item-title>
                {{ name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        Looking to aquire a new licence, or other ask related questions please contact us at support@qwips.no
      </v-card>

      <h3 v-text="'The Qwips eco system'" />

      <v-card class="ma-10">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Customer portal
            </v-list-item-title>
            <v-list-item-subtitle>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-card class="ma-10">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Qwips Service System
            </v-list-item-title>
            <v-list-item-subtitle>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-card class="ma-10">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Technician app
            </v-list-item-title>
            <v-list-item-subtitle>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-card class="ma-10">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Product portal
            </v-list-item-title>
            <v-list-item-subtitle>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>